
import { StoreState } from '@/store'

import { enableScroll } from '~/plugins/helper'

import GlobalFooter from '@/components/Footer.vue'
import ContactButton from '@/components/Header/contact-button.vue'
import MenuButton from '@/components/Header/hamburger.vue'
import GlobalHeader from '@/components/Header/index.vue'

export default {
  components: {
    MenuButton,
    GlobalHeader,
    GlobalFooter,
    ContactButton
  },
  computed: {
    isShowMenu(): boolean {
      // @ts-ignore
      return (this.$store.state as StoreState).isShowMenu
    }
  },
  mounted() {
    // isShowMenuはレイアウト間で共有されるため読み込み時に閉じる(SSRで動くcreated()は避ける)
    // @ts-ignore
    this.$store.commit('SET_MENU', false)
    enableScroll()

    // loadイベントがmounted()より前に発火済みの場合リスナーが呼ばれないため、読み込み完了済みならその場でfinish()を呼ぶ
    if (document.readyState === 'complete') {
      // @ts-ignore
      setTimeout(() => this.$nuxt.$loading.finish(), 500)
    } else {
      window.addEventListener('load', () => {
        // @ts-ignore
        setTimeout(() => this.$nuxt.$loading.finish(), 500)
      })
    }
  }
}
